import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  proposalTitle: {
    id: 'account.proposals.title',
    defaultMessage: 'My Design Proposals',
  },
  proposalDetailTitle: {
    id: 'account.proposals.details.title',
    defaultMessage: 'Design Proposal',
  },
  approved: {
    id: 'account.proposals.action.approved',
    defaultMessage: 'Proposal Successfully Accepted! Thank You!',
  },
  approvedDescription: {
    id: 'account.proposals.action.approved.description',
    defaultMessage: 'We appreciate your approval of the proposal. Your decision helps us move forward with our plans. You can check your latest order status <a>here</a>',
  },
  rejected: {
    id: 'account.proposals.action.rejected',
    defaultMessage: 'Proposal Successfully Rejected. Thank You.',
  },
  rejectedDescription: {
    id: 'account.proposals.action.rejected.description',
    defaultMessage: 'Although the proposal has been rejected, we invite you to upload new artwork on the <a>order detail page</a>. This gives you the opportunity to adjust your design to better suit your needs.',
  },
  default: {
    id: 'account.proposals.action.default',
    defaultMessage: "Status doesn't exist",
  },
  defaultDescription: {
    id: 'account.proposals.action.default.description',
    defaultMessage: 'The status <b>Action</b> is invalid. Please try opening the link from the email again.',
  },
  noProposalInfo: {
    id: 'account.proposals.noProposal',
    defaultMessage: "You don't have any new proposal for order line item {lineItemNumber}",
  },
  notInProposalState: {
    id: 'account.proposals.notInProposalState',
    defaultMessage: "We may received your proposal feedback or you haven't reached the proposal step yet. You can check your latest order status <a>here</a>",
  },
  lineItemError: {
    id: 'account.proposals.lineItemNotFound',
    defaultMessage: 'Item not found for the selected order.',
  },
  proposalNotes: {
    id: 'account.proposals.notes',
    defaultMessage: 'Notes',
  },
  proposalNotesDescription: {
    id: 'account.proposals.notes.description',
    defaultMessage: 'Pellentesque feugiat congue libero et fringilla. Integer lobortis congue mauris a euismod. Etiam ut nulla eu est ullamcorper ullamcorper ut eu tortor. Mauris ultrices risus quis varius eleifend. Ut non massa nec neque bibendum condimentum a non ipsum. Praesent pulvinar nulla ante, in feugiat sapien malesuada vitae. Vestibulum accumsan odio at aliquam faucibus. Suspendisse non sem sit amet odio tincidunt tincidunt:',
  },
  AwaitingConfirmation: {
    id: 'account.proposals.status.awaitingConfirmation',
    defaultMessage: 'Waiting for response',
  },
  Approved: {
    id: 'account.proposals.status.approved',
    defaultMessage: 'Approved',
  },
  Rejected: {
    id: 'account.proposals.status.rejected',
    defaultMessage: 'Rejected',
  },
  Closed: {
    id: 'account.proposals.status.closed',
    defaultMessage: 'Closed',
  },
  acceptButton: {
    id: 'account.proposals.action.accept',
    defaultMessage: 'Accept',
  },
  rejectButton: {
    id: 'account.proposals.action.rejectButton',
    defaultMessage: 'Reject',
  },
  uploadNewArtwork: {
    id: 'account.proposals.action.uploadNewArtwork',
    defaultMessage: 'Upload New Artwork',
  },
  cutoffTimeAndPromisedArrivalDateNote: {
    id: 'account.proposals.cutoffTimeAndPromisedArrivalDateNote',
    defaultMessage: 'Note: Your proposal will not be accepted after {cutoffTime} and current promised arrival date is {promisedArrivalDate}.',
  },
  downloadArtwork: {
    id: 'account.proposals.downloadModifiedArtwork',
    defaultMessage: 'Download Modified Artwork',
  },
  modifiedArtworkPreview: {
    id: 'account.proposals.modifiedArtworkPreview',
    defaultMessage: 'Modified Artwork - {lineItemNumber}',
  },
  scenePreview: {
    id: 'account.proposals.scenePreview',
    defaultMessage: 'Scene Preview',
  },
  approvedAlertInfo: {
    id: 'account.proposals.action.alert.approved.description ',
    defaultMessage: 'Thank you for your approval, the order will go into production now. You can check your latest order status <a>here</a>',
  },
  rejectedAlertInfo: {
    id: 'account.proposals.action.alert.rejected.description',
    defaultMessage: 'Although the proposal has been rejected, we invite you to upload new artwork <a>here</a> ',
  },
  closedAlertInfo: {
    id: 'account.proposals.action.alert.closed.description',
    defaultMessage: 'Although the proposal has been closed, you can check the order details <a>here</a> ',
  },
  adjustmentButton: {
    id: 'account.proposal.adjustmentButton',
    defaultMessage: 'Adjustment',
  },
  adjustmentTitle: {
    id: 'account.proposal.adjustmentTitle',
    defaultMessage: 'Wijzigingen doorgeven',
  },
  sendAdjustmentButton: {
    id: 'account.proposal.send.adjustmentButton',
    defaultMessage: '  Send  ',
  },
  cancelAdjustmentButton: {
    id: 'account.proposal.cancel.adjustmentButton',
    defaultMessage: 'Cancel',
  },
  adjustmentText: {
    id: 'account.proposal.adjustmentText',
    defaultMessage: 'Beschrijf hier je gewenste wijzingen',
  },
  deliverNewFileButton: {
    id: 'account.proposal.deliverNewFileButton',
    defaultMessage: 'Nieuw ontwero aanleveren',
  },
  deliverNewFileModalTitle: {
    id: 'account.proposal.deliverNewFileTitle',
    defaultMessage: 'Nieuw ontwero aanleveren',
  },
  deliverNewFileModalText: {
    id: 'account.proposal.deliverNewFileText',
    defaultMessage: 'Confirm to close the proposal and be redirected to upload new artwork on the order details page.',
  },
  deliverNewFileModalConfirmButton: {
    id: 'account.proposal.deliverNewFileConfirmButton',
    defaultMessage: 'Confirm',
  },
  deliverNewFileCancelButton: {
    id: 'account.proposal.deliverNewFileCancelButton',
    defaultMessage: 'Cancel',
  },
  iterationVersionTitle: {
    id: 'account.proposal.iterationVersionTitle',
    defaultMessage: 'versie {version}',
  },
  onPublishDateText: {
    id: 'account.proposal.onPublishDateText',
    defaultMessage: 'Gepubliceerd op',
  },
});
